export default __webpack_public_path__ + "static/media/risk-off.ac9e2e0f.svg";